import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getCategoryTargets = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/category-targets`);
    return response.data;
  } catch (error) {
    console.error('Error fetching category targets:', error.response?.data || error);
    throw error;
  }
};

export const createCategoryTarget = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/category-targets`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating category target:', error.response?.data || error);
    throw error;
  }
};

export const updateCategoryTarget = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/category-targets/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating category target:', error.response?.data || error);
    throw error;
  }
};

export const deleteCategoryTarget = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/category-targets/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting category target:', error.response?.data || error);
    throw error;
  }
};
